import type { ISODateString } from './date';

export enum CostType {
  Parking = 'parking',
  Storage = 'storage',
  Garage = 'garage',
  Komorka = 'komorka',
  MiejscePostojowe = 'miejsce-postojowe',
  Commission = 'commission',
  Other = 'other',
  UsageRights = 'usage_rights',
}

export enum CostCategory {
  RelatedRooms = 'related_rooms',
  UsageRights = 'usage_rights',
  OtherServices = 'other_services',
}

export const CATEGORY_MAP: Record<CostType, CostCategory> = {
  [CostType.Parking]: CostCategory.RelatedRooms,
  [CostType.Storage]: CostCategory.RelatedRooms,
  [CostType.Garage]: CostCategory.RelatedRooms,
  [CostType.Komorka]: CostCategory.OtherServices,
  [CostType.MiejscePostojowe]: CostCategory.RelatedRooms,
  [CostType.UsageRights]: CostCategory.UsageRights,
  [CostType.Commission]: CostCategory.OtherServices,
  [CostType.Other]: CostCategory.OtherServices,
};

export const COST_TYPE_LABELS: Record<CostType, string> = {
  [CostType.Parking]: 'Miejsce parkingowe',
  [CostType.Storage]: 'Komórka',
  [CostType.Garage]: 'Garaż',
  [CostType.Komorka]: 'Komórka',
  [CostType.MiejscePostojowe]: 'Miejsce postojowe',
  [CostType.Commission]: 'Prowizja',
  [CostType.Other]: 'Inne',
  [CostType.UsageRights]: 'Prawa do korzystania',
};

export function costTypesByCategory(category: CostCategory): CostType[] {
  return Object.entries(CATEGORY_MAP)
    .filter(([, cat]) => cat === category)
    .map(([type]) => type as CostType);
}

export class AdditionalCost {
  readonly id: string;
  readonly propertyId: string;
  readonly costType: CostType;
  readonly description: string;
  readonly amount: number;
  readonly validFrom: ISODateString;
  readonly isOptional: boolean;
  readonly isIncludedInPrice: boolean;

  constructor(data: {
    id: string;
    propertyId: string;
    costType: CostType;
    description: string;
    amount: number;
    validFrom: ISODateString;
    isOptional: boolean;
    isIncludedInPrice: boolean;
  }) {
    this.id = data.id;
    this.propertyId = data.propertyId;
    this.costType = data.costType;
    this.description = data.description;
    this.amount = data.amount;
    this.validFrom = data.validFrom;
    this.isOptional = data.isOptional;
    this.isIncludedInPrice = data.isIncludedInPrice;
  }

  get isMandatory(): boolean {
    return !this.isOptional && !this.isIncludedInPrice;
  }

  get category(): CostCategory {
    return CATEGORY_MAP[this.costType];
  }

  get displayName(): string {
    return COST_TYPE_LABELS[this.costType];
  }
}
